import React from 'react';
import { InputTypeMask } from '.';

const mask = ['(', /[0-9]/, /[0-9]/, ')', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];

export default props => <InputTypeMask {...props} mask_={mask} />;
